module.exports = __webpack_public_path__ + "static/criteo-ads-logo-dbf558369e42f2594fc967a70d4c6bdd.png";